import { Phone, WhatsappLogo, Trash, PaperPlaneTilt, CheckCircle, LockSimple } from '@phosphor-icons/react';
import { statusGroup, GROUP_STYLE, PRIMARY_STATUSES, FINAL_STATUSES, waLink, telLink, fmtDate } from './helpers';

export const LineupRow = ({ row, readOnly, showDate = false, isOwner, onStatusChange, onDelete, onSendToTracker }) => {
  const g = statusGroup(row.status);
  const st = GROUP_STYLE[g];
  const isGoing = g === 'green';
  const waText = `Hi ${row.candidate_name}, this is Tulsi Jobs. Confirming your interview lineup at ${row.company_name}${row.role ? ` for ${row.role}` : ''}. All the best!`;
  const iconBtn = 'p-2 border-2 border-black rounded hover:-translate-y-0.5 hover:shadow-[2px_2px_0px_0px_rgba(10,10,10,1)] transition-all';

  return (
    <tr className={`${st.row} text-white transition-colors`} data-testid={`lineup-row-${row.id}`} data-status-group={g}>
      <td className="px-3 py-2">
        <div className="font-black text-sm">{row.candidate_name}{showDate && <span className="ml-2 px-1.5 py-0.5 bg-white/15 border border-white/30 rounded text-[10px] font-bold" data-testid={`row-date-${row.id}`}>{fmtDate(row.date)}</span>}</div>
        <div className="text-[11px] text-white/80 font-medium">
          Lined up by: <span className="text-[#FDE047] font-bold">{row.lineup_by || '—'}</span>
          {row.telecaller && <> · Caller: <span className="text-[#93C5FD] font-bold">{row.telecaller}</span></>}
        </div>
      </td>
      <td className="px-3 py-2 font-bold text-sm whitespace-nowrap">{row.mobile}</td>
      <td className="px-3 py-2 text-sm font-medium">{row.role || '—'}</td>
      <td className="px-3 py-2 text-sm font-bold">{row.company_name}</td>
      <td className="px-3 py-2">
        {readOnly ? (
          <span className={`px-2 py-1 rounded-md border-2 border-black text-[11px] font-black uppercase ${st.badge}`} data-testid={`status-badge-${row.id}`}>{row.status}</span>
        ) : (
          <select
            data-testid={`status-select-${row.id}`}
            value={row.status}
            onChange={(e) => onStatusChange(row, e.target.value)}
            className={`px-2 py-1.5 rounded-md border-2 border-black text-xs font-black uppercase cursor-pointer ${st.badge}`}
          >
            <optgroup label="Primary status">
              {PRIMARY_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
            </optgroup>
            <optgroup label="Final status (after interview)">
              {FINAL_STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
            </optgroup>
          </select>
        )}
        {row.status === 'Not Going' && row.not_going_reason && (
          <div className="text-[10px] font-bold text-[#FCA5A5] mt-1" data-testid={`reason-${row.id}`}>Reason: {row.not_going_reason}</div>
        )}
      </td>
      <td className="px-3 py-2">
        <div className="flex gap-1.5 items-center">
          {telLink(row.mobile) && (
            <a data-testid={`call-${row.id}`} href={telLink(row.mobile)} title="Call" className={`${iconBtn} bg-white text-black`}>
              <Phone size={16} weight="fill" />
            </a>
          )}
          {waLink(row.mobile) && (
            <a
              data-testid={`whatsapp-${row.id}`}
              href={waLink(row.mobile, isGoing ? waText : '')}
              target="_blank"
              rel="noopener noreferrer"
              title={isGoing ? 'WhatsApp confirmation to candidate' : 'WhatsApp'}
              className={`${iconBtn} ${isGoing ? 'bg-[#25D366] text-black animate-pulse' : 'bg-[#25D366]/40 text-black'}`}
            >
              <WhatsappLogo size={16} weight="fill" />
            </a>
          )}
          {row.tracker_candidate_id ? (
            <span data-testid={`in-tracker-${row.id}`} title="Already in Tracker" className="flex items-center gap-1 px-2 py-1 bg-[#A3E635] text-black border-2 border-black rounded text-[10px] font-black">
              <CheckCircle size={12} weight="fill" /> IN TRACKER
            </span>
          ) : (
            <button data-testid={`send-tracker-${row.id}`} onClick={() => onSendToTracker(row)} title="Send to Candidate Tracker" className={`${iconBtn} bg-[#A3E635] text-black`}>
              <PaperPlaneTilt size={16} weight="fill" />
            </button>
          )}
          {readOnly && <LockSimple size={16} weight="fill" className="text-white/50 ml-1" title="Archived — read only" />}
          {!readOnly && isOwner && (
            <button data-testid={`delete-${row.id}`} onClick={() => onDelete(row)} title="Delete" className={`${iconBtn} bg-[#F87171] text-white`}>
              <Trash size={16} weight="bold" />
            </button>
          )}
        </div>
      </td>
    </tr>
  );
};
